var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useFocusVisible } from '../../hooks/useFocusVisible';
import { Stack } from '../Stack';
import { Icon } from '../Icon';
import { BodyText } from '../BodyText';
import { Tag } from '../Tag';
export const FilterButton = React.forwardRef((_a, ref) => {
    var { className, icon, onClick, expandIcon = null, value, label } = _a, rest = __rest(_a, ["className", "icon", "onClick", "expandIcon", "value", "label"]);
    const [IValue, setIValue] = React.useState(value);
    const newRef = React.useRef(null);
    const itemRef = ref ? ref : newRef;
    const { isFocusVisible } = useFocusVisible(itemRef);
    const filterButtonClassName = classnames('FilterButton', className, {
        'FilterButton--active': IValue,
        'FilterButton--focus-visible': isFocusVisible,
    });
    const onClickHandler = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    React.useEffect(() => {
        setIValue(value);
    }, [value]);
    return (React.createElement("button", Object.assign({ className: filterButtonClassName, onClick: () => onClickHandler(), ref: itemRef, "aria-expanded": expandIcon, "aria-label": `Filter ${label}`, "aria-pressed": !!IValue, "data-anvil-component": "FilterButton" }, rest),
        React.createElement(Stack, { alignItems: "center" },
            icon && (React.createElement(Icon, { name: icon, size: "16px", className: "FilterButton__Icon" })),
            !icon && label && (React.createElement(BodyText, { el: "span", size: "small", className: "FilterButton__Label" }, label)),
            typeof IValue === 'string' ? (React.createElement(BodyText, { el: "span", size: "small" },
                `: `,
                React.createElement(BodyText, { el: "span", size: "small", bold: true }, IValue))) : typeof IValue === 'number' ? (React.createElement(Tag, { color: "info", badge: true, compact: true, className: "FilterButton__Tag" }, IValue)) : null,
            expandIcon !== null && (React.createElement(Icon, { name: expandIcon
                    ? 'keyboard_arrow_up'
                    : 'keyboard_arrow_down', className: "FilterButton__ExpandIcon" })))));
});
//# sourceMappingURL=FilterButton.js.map